import type { QuoteCarouselFormat } from './types';

export const SLIDE_FORMATS: Record<QuoteCarouselFormat, { width: number; height: number }> = {
  portrait_4x5: { width: 1080, height: 1350 },
  portrait_9x16: { width: 1080, height: 1920 },
};
